import { AUTH_API } from '../../../../../api/amplify';
import { wait } from '../../../../../utils/commonHelpers';
import { Button } from './styled';
import { useState } from 'react';

export const ElamaSigninButton = () => {
  const [isLoading, setIsLoading] = useState(false);

  const onElamaSignin = async () => {
    try {
      setIsLoading(true);
      await wait(1000);
      await AUTH_API.elamaSignIn();
    } catch (e) {
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  return (
    <Button isLoading={isLoading} onClick={onElamaSignin}>
      Войти через eLama
    </Button>
  );
};
